import styles from "./FolderList.module.scss";
import { DropDownIcon } from "../../../../../../assets/svg/DropDownIcon";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/store";
import {
  getFolders,
  getPathToRootString,
  getPrevFolderSafe,
  getCurrentFolder,
  getCurrentCategoryFolder,
} from "../../../../../../redux/reducers/ui/selectors/objectSelectors";
import { setActiveFolder } from "../../../../../../redux/reducers/ui/uiReducer";
import { getCategoryInfoThunk, searchProductsThunk } from "../../../../../../redux/reducers/ui/uiThunks";
import { FolderItem } from "./FolderItem/FolderItem";
import {
  getIsSearching,
  getSearchFolders,
  getSearchValue,
} from "../../../../../../redux/reducers/ui/selectors/searchSelectors";
import clsx from "clsx";
import { useEffect } from "react";

export const FolderList = () => {
  const dispatch = useAppDispatch();
  const folders = useAppSelector(getFolders);
  const prevFolder = useAppSelector(getPrevFolderSafe);
  const currentFolder = useAppSelector(getCurrentFolder);
  const pathString = useAppSelector(getPathToRootString);
  const isSearching = useAppSelector(getIsSearching);
  const searchFolders = useAppSelector(getSearchFolders);
  const searchValue = useAppSelector(getSearchValue);
  const currentCategoryFolder = useAppSelector(getCurrentCategoryFolder);

  // Fetch category info when we're inside a specific folder
  useEffect(() => {
    console.log("useEffect triggered with currentFolder:", currentFolder);
    // If we have a current folder, fetch its detailed info
    if (currentFolder && currentFolder.id) {
      dispatch(getCategoryInfoThunk(currentFolder.id));
    }
  }, [currentFolder, dispatch]);

  // Trigger server-side product search when search value changes
  useEffect(() => {
    const value = searchValue?.trim();
    if (value && value.length > 0) {
      dispatch(searchProductsThunk(value));
    }
  }, [dispatch, searchValue]);

  const handleBack = () => {
    dispatch(setActiveFolder(prevFolder));
  };

  // Logic for showing folders:
  // - If searching: show search results
  // - If at root level (no currentFolder): show main categories (folders)
  // - If inside a category (has currentFolder): show only currentCategoryFolder children
  const resFolders = isSearching
    ? searchFolders
    : currentFolder
      ? currentCategoryFolder?.children || []
      : folders;

  return (
    <div className={styles.wrapper}>
      {!isSearching && (
        <div className={styles.path_wrapper}>
          <button disabled={!pathString.length} onClick={handleBack}>
            <DropDownIcon /> Back
          </button>
          <div className={styles.path}>{pathString}</div>
          <div className={styles.spacer}></div>
        </div>
      )}
      {isSearching && (
        <div className={clsx(styles.path_wrapper, styles.search_wrapper)}>
          <div className={styles.search_result}>Search Results</div>
        </div>
      )}
      {resFolders.length > 0 && (
        <div className={styles.list}>
          {resFolders.map((folder, index) => (
            <FolderItem key={index} folder={folder} />
          ))}
        </div>
      )}
    </div>
  );
};
